<template>
  <div class="homepage">
    <headingComp>
      <section class="slider-container">
        <div class="slider" v-for="(slider, key) in sliders" :key="key">
          <article class="slide" :class="{'active': key === activeSlider}" 
            :style="{'background-image': `url(${require('@/assets/elvas-castelo.jpg')}`, left: `${100 * (key - activeSlider)}%`}">
            <div class="text-container">
              <p class="upper-title">{{slider.uppertitle}}</p>
              <p class="title">{{slider.title}}</p>
              <elvasButton :button="{title: 'Saber mais'}"></elvasButton>
            </div>
            <div class="slide-mask" />
          </article>
        </div>
        <section class="slider-selector">
          <div class="slide-select"  v-for="(slider, key) in sliders" :key="key">
            <div class="slider-exterior">
              <div class="slider-progression" :class="{'active': isActive(key)}"></div>
            </div>
            <p class="slide-select-title">{{slider.title}}</p>
          </div>
        </section>
      </section>
    </headingComp>
    <section class="video-container">
      <div class="video-text fade-in" data-fade-length="1500ms">
        <h4>Uma cidade cheia de Historia e segredos</h4>
        <p>Suspendisse accumsan odio vel felis tempor, eu luctus enim viverra. 
          Vestibulum at vulputate nisl. Duis ultricies massa sed ultrices viverra. 
          Donec rhoncus justo quis placerat placerat. Aliquam consectetur, nisl ut vestibulum posuere.</p>
        <div class="video-container-scroll-down">
          <p>scroll down</p>
          <img @click="scrollDown()" src="@/assets/arrow.svg">
        </div>
        <img class="background-filter" src="@/assets/textura-elvas-branco@3x.png"/>
      </div>
      <div class="temp-video fade-in" >
        <video controls autoplay src="@/assets/videos/1.mp4" />
        <div class="overlay"></div>
      </div>
    </section>
    <section class="locations-section" v-if="loaded">
      <section class="onde-dormir" v-if="whereToSleep && whereToSleep.length">
        <h4 class="main-title fade-in">Onde Dormir</h4>
        <img class="icon" src="@/assets/ic-white-onde-dormir.svg">
        <interestPoint class="component-very-large fade-in" v-if="whereToSleep.length >= 1" :interestPoint="{id: '1', translation: {title: 'Hotel D. Sancho II'}, images: [{image_url: 'https://picsum.photos/seed/omnis/1200/800'}]}" :url="'/estalagem#hotel'" />
      </section>
      <section class="o-que-visitar" v-if="whatToVisit && whatToVisit.length">
        <h4 class="main-title fade-in">O que Visitar</h4>
        <img class="icon" src="@/assets/ic-white-o-que-visitar.svg">

        <div class="interests-points-wrapper">
          <interestPoint class="component-small fade-in" v-if="whatToVisit.length >= 1" :interestPoint="whatToVisit[0]"/>
          <interestPoint class="component-small fade-in" v-if="whatToVisit.length >= 2" :interestPoint="whatToVisit[1]"/>
          <interestPoint class="component-small fade-in" v-if="whatToVisit.length >= 3" :interestPoint="whatToVisit[2]"/>
        </div>
        <div class="see-more fade-in" data-fade-length="750ms">
          <router-link to="/pontosDeInteresse?type=o_que_visitar">
            <p>Ver mais</p>
            <div class="see-more-icon">
              <img class="no-filled" src="@/assets/arrow-no-filled.svg">
              <img class="filled" src="@/assets/arrow-filled.svg">
            </div>
          </router-link>
        </div>
      </section>
      <section class="onde-comer" v-if="whereToEat && whereToEat.length">
        <h4 class="main-title fade-in" data-fade-length="750ms">Onde comer</h4>
        <img class="icon" src="@/assets/ic-white-onde-comer.svg">
        <div class="interests-points-wrapper">
          <interestPoint class="component-large fade-in" v-if="whereToEat.length >= 1" :interestPoint="whereToEat[0]"/>
          <interestPoint class="component-small fade-in" v-if="whereToEat.length >= 2" :interestPoint="whereToEat[1]"/>
        </div>
      </section>
      <section class="onde-comprar" v-if="whereToBuy && whereToBuy.length">
        <h4 class="main-title fade-in">Onde Comprar</h4>
        <img class="icon" src="@/assets/ic-white-ponde-comprar.svg">
        <div class="interests-points-wrapper">
          <interestPoint class="component-small fade-in" v-if="whereToBuy.length >= 1" :interestPoint="whereToBuy[0]"/>
          <interestPoint class="component-small fade-in" v-if="whereToBuy.length >= 2" :interestPoint="whereToBuy[1]"/>
          <interestPoint class="component-small fade-in" v-if="whereToBuy.length >= 3" :interestPoint="whereToBuy[2]"/>
        </div>
        <div class="see-more fade-in" data-fade-length="750ms">
          <router-link to="/pontosDeInteresse?type=onde_comprar">
            <p>Ver mais</p>
            <div class="see-more-icon">
              <img class="no-filled" src="@/assets/arrow-no-filled.svg">
              <img class="filled" src="@/assets/arrow-filled.svg">
            </div>
          </router-link>
        </div>
      </section>
      <router-link to="/pontosDeInteresse"><elvasButton class="see-all-interess-points fade-in" :button="{title: 'Ver todos os pontos de interesse'}"></elvasButton></router-link>
    </section>
    
    <section class="map">
      <img src="@/assets/group-3-copy-8@3x.jpg" class="map-image fade-in">
      <section class="map-text fade-in">
        <p class="map-upper-title">MAPA INTERACTIVO DA CIDADE</p>
        <p class="map-title">Veja aqui o mapa da cidade e os percursos sugeridos</p>
        <router-link to="/percursos"><elvasButton :button="{title: 'VER PERCURSOS'}"></elvasButton></router-link>
      </section>

      <!--
      <svg class="map-line fade-in"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="575" height="327">
        <defs>
          <mask id="graph">
            <g stroke-linecap="round" stroke-linejoin="round">
              <use fill="#000" filter="url(#b)" xlink:href="#c"/>
              <use stroke="white" stroke-width="4" xlink:href="#c"/>
            </g>
            <circle cx="9" cy="238" r="9" fill="white" />
            <circle cx="518" cy="72" r="9" fill="white" />
          </mask>
          <filter id="a" width="129.8%" height="167.6%" x="-15.2%" y="-28.7%" filterUnits="objectBoundingBox">
              <feOffset dy="16" in="SourceAlpha" result="shadowOffsetOuter1"/>
              <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="4"/>
              <feColorMatrix in="shadowBlurOuter1" result="shadowMatrixOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
              <feMerge>
                  <feMergeNode in="shadowMatrixOuter1"/>
                  <feMergeNode in="SourceGraphic"/>
              </feMerge>
          </filter>
          <path id="c" d="M9 238l46.41-27.072a2 2 0 0 0 .797-2.59L36 166l83.06-69.712a2 2 0 0 1 2.069-.308l18.273 7.766a2 2 0 0 1 .932.811L150.5 121.5l28.186-16.926L205.5 135.5c8.524-8.575 15.857-17.742 22-27.5 12.605-28.716 22.272-47.216 29-55.5 8.017-9.872 20.551-18.81 37.603-26.814a2 2 0 0 1 .83-.19c10.022-.1 19.877-1.766 29.567-4.996 9.582-3.194 24.555-9.77 44.918-19.725a2 2 0 0 1 2.55.698l33.055 50.302a2 2 0 0 0 1.332.872L516 71.553"/>
          <filter id="b" width="127.6%" height="158.4%" x="-13.8%" y="-22.2%" filterUnits="objectBoundingBox">
              <feMorphology in="SourceAlpha" operator="dilate" radius="1.5" result="shadowSpreadOuter1"/>
              <feOffset dy="16" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/>
              <feMorphology in="SourceAlpha" radius="1.5" result="shadowInner"/>
              <feOffset dy="16" in="shadowInner" result="shadowInner"/>
              <feComposite in="shadowOffsetOuter1" in2="shadowInner" operator="out" result="shadowOffsetOuter1"/>
              <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="20"/>
              <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          </filter>
        </defs>
        <g id="line-color" mask="url(#graph)">
          <rect x="-100%" y="0" width="100%" height="100%" fill="#3363D7"/>
          <rect x="0" y="0" width="100%" height="100%" fill="black"/>
        </g>
      </svg>
      -->


      
      <svg class="map-line fade-in" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="634" height="319" viewBox="0 0 634 319">
        <defs>
          <filter id="75sqydnoea" width="131.4%" height="190.1%" x="-16%" y="-36.9%" filterUnits="objectBoundingBox">
              <feOffset dy="16" in="SourceAlpha" result="shadowOffsetOuter1"/>
              <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="4"/>
              <feColorMatrix in="shadowBlurOuter1" result="shadowMatrixOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
              <feMerge>
                  <feMergeNode in="shadowMatrixOuter1"/>
                  <feMergeNode in="SourceGraphic"/>
              </feMerge>
          </filter>
          <path id="t4pxxj3l7c" d="M9 171l83.06-69.712c.577-.483 1.376-.603 2.069-.308l18.273 7.766c.389.165.715.45.932.811L123.5 126.5l28.186-16.926L178.5 140.5c8.524-8.575 15.857-17.742 22-27.5 12.605-28.716 22.272-47.216 29-55.5 8.017-9.872 20.551-18.81 37.603-26.814.26-.122.542-.186.83-.19 10.022-.1 19.877-1.766 29.567-4.996 9.582-3.194 24.555-9.77 44.918-19.725.905-.442 1.997-.143 2.55.698l33.055 50.302c.304.462.787.778 1.332.872L489 76.553"/>
          <mask id="graph">
            <g fill="none" fill-rule="evenodd">
                <g filter="url(#75sqydnoea)" transform="translate(-743 -4102) translate(811 4157)">
                    <g stroke-linecap="round" stroke-linejoin="round">
                        <use fill="#000" filter="url(#2pfea7d3kb)" xlink:href="#t4pxxj3l7c"/>
                        <use stroke="#A79374" stroke-width="4" xlink:href="#t4pxxj3l7c"/>
                    </g>
                    <circle cx="9" cy="171" r="9" fill="#A79374"/>
                    <circle cx="153" cy="112" r="9" fill="#A79374"/>
                    <circle cx="344" cy="9" r="9" fill="#A79374"/>
                    <circle cx="491" cy="77" r="9" fill="#A79374"/>
                </g>
            </g>
          </mask>
        </defs>
        <g id="line-color" mask="url(#graph)">
          <rect x="-100%" y="0" width="100%" height="100%" fill="#f6b92f"/>
          <rect x="0" y="0" width="100%" height="100%" fill="black"/>
        </g>
      </svg>
      <img class="texture texture-1" src="@/assets/textura-elvas-1@3x.png">
      <img class="texture texture-2" src="@/assets/textura-elvas-2@3x.png">
      <img class="texture texture-3" src="@/assets/textura-elvas-3@3x.png">
    </section>
    <section class="elvas-video">
      <img class="oh-elvas-footer-title fade-in" src="@/assets/oh-elvas-footer.svg">
      <div class="elvas-video-container fade-in" >
        <video autoplay src="@/assets/videos/A.mp4" />
        <div class="overlay"></div>
      </div>
    </section>
  </div>
</template>

<script>
import elvasButton from '@/components/elvas-button.vue'

export default {
  name: 'home',
  components: {
    elvasButton
  },
  data () {
    return {
      sliders: [
        {
          uppertitle: 'guia de elvas',
          title: 'Bem-vindo à maior cidade fortificada da Europa',
          percentage: 30
        },
        {
          uppertitle: 'guia de elvas',
          title: 'Bem-vindo à maior cidade fortificada da Europa',
          percentage: 50
        },
        {
          uppertitle: 'guia de elvas',
          title: 'Bem-vindo à maior cidade fortificada da Europa',
          percentage: 50
        }
        
      ],
      sliderMounted: false,
      activeSlider: 0,
      whereToEat: null,
      whatToVisit: null,
      whereToSleep: null,
      whereToBuy: null
    }
  },
  async mounted () {
    this.initiateSlider()
    this.initiateFadeIn()
    window.addEventListener('scroll', () => {
      let scrollDiff =  150 - 500 * (document.documentElement.scrollHeight - window.pageYOffset) / document.documentElement.scrollHeight
      this.$el.querySelector('.oh-elvas-footer-title').style.transform = `translateY(${scrollDiff}px)`;
    })

    this.api.get('interestPoint?type=onde_comer').then(response => {
      this.whereToEat = response
    })
    this.api.get('interestPoint?type=o_que_visitar').then(response => {
      this.whatToVisit = response
    })
    this.api.get('interestPoint?type=onde_dormir').then(response => {
      this.whereToSleep = response
    })
    this.api.get('interestPoint?type=onde_comprar').then(response => {
      this.whereToBuy = response
    })
  },
  computed: {
    loaded: function () {
      return this.whereToEat && this.whatToVisit && this.whereToSleep && this.whereToBuy
    }
  },
  methods: {
    initiateSlider () {
      this.$nextTick(() => {
        this.sliderMounted = true
      })
      setInterval(() => {
        if (this.activeSlider < this.sliders.length - 1) {
          this.activeSlider++
        } else {
          this.activeSlider = 0
        }
      }, 5000)
    },
    isActive (key) {
      if (!this.sliderMounted) return false
      return key === this.activeSlider
    },
    initiateFadeIn () {
      addEventListener('scroll', () => {
        this.fadeFunction()
      })
      this.fadeFunction()
    },
    fadeFunction () {
      let elements = this.$el.querySelectorAll('.fade-in:not(.faded)')
      for (let i = 0; i < elements.length; i++) {
        let element = elements[i]
        if (element.getBoundingClientRect().top < window.innerHeight) {
          if (element.tagName === 'svg') {
            let rects = this.$el.querySelectorAll('rect')
            for (let i = 0; i < rects.length; i++) {
              rects[i].classList.add('fill')
            }
          } else {
            let duration = element.getAttribute('data-fade-length')
            element.style.transition = 'all ' + duration
          }
          element.classList.add('faded')
        }
      }
    },
    scrollDown () {
      window.scrollTo({top: window.innerHeight - 80, behavior: 'smooth' });
    }
  }
}
</script>
<style lang="scss" scoped>
.header {
  width: 100%;
  display: flex;
  position: relative;
  z-index: 5;
  .slider-container {
    height: 100vh;
    width: 100%;
    background: rgb(240, 241, 243);
    position: relative;
    overflow: hidden;
    .slide {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      background-size: cover;
      transition: 1.5s all;
      .text-container {
        margin-left: 128px;
        text-align: left;
        z-index: 2;
        color: white;
        .upper-title {
          text-transform: uppercase;
          margin-bottom: 8px;

          text-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
          font-family: 'Barlow Condensed', sans-serif;
          font-size: 24px;
          font-weight: 500;
          font-stretch: condensed;
          font-style: normal;
          line-height: 1.08;
          letter-spacing: 0.6px;
          color: #ffffff;
        }
        .title {
          width: 60%;
          text-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
          font-family: 'Sen', serif;
          font-size: 64px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 1;
          letter-spacing: -1.14px;
        }
        .elvas-button {
          margin-top: 80px;
        }
        @media (max-width: 1100px){
          .title {
            width: 85%;
          }
        }

        @media (max-width: 600px){
          margin-left: 16px;
          max-width: 90%;
          .upper-title {
            font-size: 18px;
          }
          .title {
            font-size: 24px;
          }
        }
      }
      .slide-mask {
        position: absolute;
        opacity: 0.5;
        background-color: #242424;
        z-index: 1;
        height: 100%;
        width: 100%;
      }
    }
    .slider-selector {
      right: 25%;
      left: 25%;
      margin: auto;
      position: absolute;
      bottom: 150px;
      display: flex;
      justify-content: space-around;
      z-index: 3;
      .slide-select {
        padding-top: 15px;
        margin: 0 20px;
        flex: 1 1 0px;
        .slider-exterior {
          margin-bottom: 10px;
          width: 100%;
          height: 3px;
          background-color: rgba(255, 255, 255, 0.25);
          .slider-progression {
            background: white;
            height: 3px;
            width: 0%;
          }
          .slider-progression.active {
            transition: 5s all linear;
            width: 100%;
          }
        }
        p {
          text-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
          font-family: 'Sen', sans-serif;
          font-size: 16px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          color: #ffffff; 
          line-height: 1.13;
          letter-spacing: -0.36px;
        }
      }

      @media (max-width: 1260px){
        left: 35%;
        right: 15%;
      }

       @media (max-width: 1100px){
        left: 45%;
        right: 5%;
      }

      @media (max-width: 880px){
        bottom: 70px;
        left: 15%;
        right: 5%;
      }
    }
  }

  
    @media (max-width: 600px){
      max-height: 348px;
      min-height: 348px !important;

      .slider-container {
        height: 348px;

        .slider-selector  {
          bottom: 24px;
          left: 0;
          right: 0;
        }

        .slide-select .slide-select-title {
          display: none;
        }

        .text-container {
          margin-top: 40px;

          .elvas-button {
            margin-top: 56px !important;
            /* margin-bottom: 32px; */
          }
        }
      }
    }
}
.video-container {
  position: relative;
  margin-top: -74px;
  display: flex;
  flex-wrap: wrap;
  z-index: 6;

  .video-text {
    background-color: #a79374;
    padding: 80px 180px 150px 180px;
    width: calc(60% - 360px);
    margin-left: calc(40% - 80px);
    position: relative;
    overflow: hidden;
    img.background-filter {
      position: absolute;
      top: 0;
      left: 0;
    }
    h4 {
      font-family: 'Sen', sans-serif;
      font-size: 48px;
      line-height: 1.13;
      letter-spacing: -1px;
      color: #ffffff;
      margin-bottom: 24px;
      width: 80%;
    }
    p {
        font-family: 'Sen', sans-serif;
        font-size: 18px;
        line-height: 1.56;
        letter-spacing: -0.4px;
        color: #ffffff;
    }
    .video-container-scroll-down {
      position: absolute;
      right: 24px;
      top: 24px;
      display: flex;
      align-items: center;
      p {
        font-family: 'Sen', sans-serif;
        font-size: 14px;
        font-weight: bold;
        line-height: 1;
        letter-spacing: 1px;
        text-transform: uppercase;
        margin-right: 15px;
      }
      img {
        cursor: pointer;
      }
    }
  }
  .temp-video {
    width: 60%;
    height: 30vw;
    margin-top: -100px;
    margin-left: 80px;
    box-shadow: 0 32px 40px 0 rgba(0, 0, 0, 0.32);
    background-size: cover;
    //background: url('@/assets/video.jpg')
    overflow: hidden;
    video {
      width: 100%;
    }
    .overlay {
      opacity: 0.5;
      background: #f6b92f;
      height: 100%;
      width: 100%;
      position: absolute;
      top: 0;
    }
  }

  @media (max-width: 1450px){
    .temp-video {
      height: 28vw;
    }
  }

  @media (max-width: 1280px) {
    .video-text {
      padding: 80px 130px 90px 130px; 
      width: 55vw;
      margin-left: 20%;
    }

    .temp-video {
      margin-top: -80px;
      margin-left: 40px;
    }
  }

  @media (max-width: 940px){
    .video-text {
      padding: 80px 100px 90px 100px; 
      width: 57vw;
      margin-left: 15%;
    }
  }

  @media (max-width: 880px){
    margin-top: -32px;
    .temp-video {
      height: 24.5vw;
    }
  }

  @media (max-width: 800px){
    .video-text {
      padding: 80px 50px 90px 50px; 
      width: 55vw;
      margin-left: 25%;
    }
  }

  @media (max-width: 700px) {
    margin-top: 16px;
    .video-text {
      background-color: #a79374;
      padding: 32px 16px 90px 16px;
      width: 100%;
      margin-left: 16px;
      margin-right: 16px;
      position: relative;
      overflow: hidden;

      h4 {
        font-size: 24px;
      }

      p {
        font-size: 18px;
      }

      .video-container-scroll-down{
        top: 36px;
        p {
          display: none;
        }
      }
   
    }
     .temp-video {
      margin-top: -70px;
      width: calc(100% - 64px);
      height: 100%;
      margin-left: 32px;
    }
  }
}
.locations-section {
  background-color: #f6ede0;
  padding-bottom: 170px;
  position: relative;
  padding-top: 100px;
  margin-top: -100px;

  @media (max-width: 900px){
    margin-top: -50px;
    padding-top: 50px;
  }

  @media (max-width: 660px){
    margin-top: -20px;
    padding-top: 20px;
  }

  @media (max-width: 600px){
    margin-top: -30px;
    padding-top: 20px;
    padding-bottom: 20px;
  }
}
.onde-comer {
  z-index: 3;
}
.o-que-visitar {
  z-index: 2;
}
.onde-comer, .onde-dormir, .o-que-visitar, .onde-comprar {
  position: relative;
  display: flex;
  margin-top: 150px;
  .interest-point-item /deep/ .image {
    transition: all 1s;
    img {
      object-position: center;
      object-fit: cover;
      width:100%;
      height:100%;
    }
    &:hover {
      box-shadow: 0 32px 40px 0 rgba(0, 0, 0, 0.25);
    }

    @media (max-width: 1024px){
      margin-top: 70px;
      img {
         height: auto;
      }
    }
  }
  .main-title {
    position: absolute;
    font-size: 64px;
    left: 80px;
    font-family: 'Sen';
    font-weight: bold;
    letter-spacing: -1px;
    text-transform: uppercase;
    z-index: 4;
    color: #f6b92f;
    margin-top: -40px;

    @media (max-width: 1024px){
      font-size: 32px;
      left: 16px;
      margin-top: -20px;
    }
    
  }
  .interest-point-item /deep/ .title {
    color: #a79374;
  }
  .interest-point-item /deep/ .description {
    color: #a79374;
  }
  .component-very-large {
    position: relative;
    width: 72.5%;
    margin-left: 12.5%;
    z-index: 2;
    &.interest-point-item /deep/ .image {
      height: 700px;
    }

    @media (max-width: 1024px){
      width: 100%;
      margin-left: 16px;
      margin-right: 16px;

      &.interest-point-item /deep/ .image {
      height: auto;
     }
    }
  }
  .component-large {
    position: relative;
    width: 40%;
    margin-left: 25%;
    z-index: 2;
    &.interest-point-item /deep/ .image {
      height: 400px;
    }
  }
  .component-small {
    position: relative;
    width: 20%;
    margin-left: 30px;
    &.interest-point-item /deep/ .image {
      height: 200px;
    }
  }
  .component-large, .component-small, .component-very-large {
    &.interest-point-item /deep/ .title {
      font-weight: bold;
      margin: 20px 0 10px 0;
    }
    &.interest-point-item /deep/ .image {
      width: 100%;
    }
  }
  .component-very-large, .component-large {
    &.interest-point-item /deep/ .title {
      margin-top: 24px;
    }
  }
  .component-small {
    &.interest-point-item /deep/ .title {
      margin-top: 16px;
    }
  }
}
.onde-comprar, .o-que-visitar {
  .main-title {
    left: unset;
    right: 80px;
    z-index: 3;
  }
}
.o-que-visitar, .onde-comprar {
  .component-small:first-of-type {
    margin-left: 80px;
  }
  .icon {
    position: absolute;
    width: 220px;
    height: 220px;
    right: 40px;
    top: -80px;
  }

  .interests-points-wrapper {
    display: flex;
    width: calc(60vw + 80px + 60px);

    .component-small {
      width: 100%;
    }
  }

  @media (max-width: 1024px){
    display: flex;
    flex-direction: column;
    padding: 0 16px;
    margin-top: 64px;

    .interests-points-wrapper {
      width: 100%;
    }

    .main-title {
      position: relative;
      right: 0;
      top: 70px;
      font-size: 32px;
    }

    .component-small:first-of-type, .see-more {
      margin-left: 0px;
    }

    .component-small /deep/ .image {
      height: 214px;
      margin-top: 0;
    }
    
    .icon {
      position: relative;
      width: 92px;
      height: 68px;
      top: 0;
      right: 0;
      margin-bottom: 60px;
    }

    .see-more {
      margin-top: 32px;
    }
  }
 
   @media (max-width: 700px) {
     padding-right: 0;
     overflow-x: hidden;

     .interests-points-wrapper {
       overflow-x: auto;
       padding-bottom: 16px;
       padding-right: 0px;

      .component-small:last-child {
        padding-right: 16px;
      }

      .component-small /deep/ .image {
        height: 214px;
        margin-top: 0;
        img {
          width: 298px;
          height: 214px;
        }
      }
     }
     .see-more {
      margin-top: 16px;
    }
   }
}
.onde-dormir {
  .icon {
    position: absolute;
    width: 220px;
    height: 220px;
    left: 40px;
    top: -80px;
    z-index: 3;
  }

  @media (max-width: 1024px){
    .icon {
      top: -72px;
      left: 32px;
      width: 64px;
      height: 92px;
    }
  }
}

.onde-comer {
  .component-large {
    width: 45%;
    margin-left: calc(30% - 110px);
  }
  .icon {
    position: absolute;
    width: 220px;
    height: 220px;
    left: 40px;
    top: -80px;
  }
  .interests-points-wrapper {
    display: flex;
    width: 100%;
  }

  @media (max-width: 1024px){
  display: flex;
  flex-direction: column;
  padding: 0 16px;
  margin-top: 64px;


  .component-large {
    width: 100%;
    margin-left: 0;
  }

  .interests-points-wrapper {
    width: 100%;
  }

  .main-title {
    position: relative;
    right: 0;
    left: 0;
    top: 70px;
    font-size: 32px;
  }

  .component-small:first-of-type, .see-more {
    margin-left: 0px;
  }

  .component-small, .component-large {
    width: 50%;
  }

  .component-small /deep/.image, .component-large  /deep/.image {
    height: 310px !important;
    margin-top: 0;
  }

  .icon {
    position: relative;
    width: 92px;
    height: 68px;
    top: 0;
    right: 0;
    left: 0;
    margin-bottom: 60px;
  }

  .see-more {
    margin-top: 32px;
  }
}

  @media (max-width: 700px) {
    padding-right: 0;
    overflow-x: hidden;

    .interests-points-wrapper {
      overflow-x: auto;
      padding-bottom: 16px;
      padding-right: 0px;

    .component-small:last-child {
      padding-right: 16px;
    }

    .component-large, .component-small{
      height: auto;
      width: 100%;
    }

    .component-small /deep/ .image, .component-large /deep/ .image {
      height: 214px !important;
      margin-top: 0;
      width: 298px;
      img {
        width: 298px;
        height: 214px;
      }
    }
    }
    .see-more {
    margin-top: 16px;
  }
  }
}
.see-all-interess-points {
  margin: 100px auto;
  background: #f6b92f;
  &:hover {
    background: #ffb24f;
  }

  @media (max-width: 460px){
    padding: 14px 12px;
    margin-top: 80px;
  }
}
.map {
  position: relative;
  margin-top: 130px;
  margin-bottom: 150px;
  .map-text {
    margin-left: 80px;
    position: absolute;
    top: 0;
    z-index: 3;
    .map-upper-title {
      font-family: 'Barlow Condensed';
      font-size: 24px;
      font-weight: 500;
      font-stretch: condensed;
      line-height: 1.08;
      letter-spacing: 0.6px;
      color: #0d3677;
      margin-bottom: 15px;
      margin-top: 50px;
    }
    .map-title {
      font-size: 48px;
      font-weight: bold;
      line-height: 1.13;
      letter-spacing: -0.86px;
      color: #0d3677;
      margin-bottom: 40px;
      width: 60%;
    }
    .elvas-button {
      p {
        font-family: 'IBM Plex Sans';
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1;
        letter-spacing: 1px;
        text-align: center;
      }
      padding: 14px 20px;
    }

   
  }
  .map-image {
    width: 80%;
    height: 450px;
    margin: 0 10%;
    background: #eee;
    z-index: 2;
    position: relative;
  }
  .map-back-image {
    position: absolute;
    width: 30%;
    margin: auto;
    display: block;
    left: 0;
    right: 0;
    bottom: -175px;
  }
  .texture {
    position: absolute;
    z-index: 2;
    &.texture-1 {
      width: 160px;
      top: -200px;
      left: 100px;
    }
    &.texture-2 {
      width: 240px;
      right: 100px;
      top: -100px;
    }
    &.texture-3 {
      width: 120px;
      left: 400px;
      bottom: -100px;  
    }
  }

  @media (max-width: 900px){
    .map-text {

      .map-title {
        font-size: 36px;
      }
    }
    .texture {
      position: absolute;
      z-index: 2;
      &.texture-1 {
        width: 120px;
        top: -200px;
        left: 100px;
      }
      &.texture-2 {
        width: 180px;
        right: 20px;
        top: -80px;
      }
      &.texture-3 {
        width: 80px;
        left: 150px;
        bottom: 30px;  
      }
    }
  }

  @media (max-width: 700px){

    .map-image {
      height: 350px;
    }
    .map-text {
      .map-title {
        font-size: 24px;
      }
    }
    .texture {
      &.texture-1 {
        width: 80px;
        top: -172px
      }
      &.texture-2 {
        width: 100px;
        right: 38px;
        top: -42px;
      }
      &.texture-3 {
        width: 60px;
        bottom: 20px;  
      }
    }
  }

   @media (max-width: 540px){
     margin-top: 54px;

    .map-image {
      height: 167px;
    }
    .map-text {
      left: -50px;
      .map-upper-title {
        font-size: 18px;
        margin-top: 36px;
        margin-bottom: 8px;
      }
      .map-title {
        font-size: 18px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1;
        letter-spacing: -0.32px;
      }

      a {
        display: none;
      }
    }
    .texture {
      &.texture-1 {
        width: 56px;
        top: -85px;
        left: 40px;
      }
      &.texture-2 {
        width: 80px;
        right: 38px;
        top: -36px;
      }
      &.texture-3 {
        width: 60px;
        bottom: -15px;  
        left: 100px;
      }
    }
  }
}
#line-color {
  rect {
    transition: all 6s;
    &.fill {
      transform: translateX(100%);
    }
  }
}
mask {
  & > * {
    transform: translateY(10px);
  }
}
.map-line {
  position: absolute;
  right: calc(10% - 45px);
  bottom: -40px;
  z-index: 5;

  @media (max-width: 900px){
    width: 500px;
    bottom: 0%;
    right: 10px;
  }

  @media (max-width: 700px){
    width: 300px;
    bottom: 0%;
    right: 10px;
  }
  @media (max-width: 540px){
    width: 250px;
    bottom: 10px;
    right: 30px;
    height: 120px;
  }

  @media (max-width: 420px){
    width: 200px;
    bottom: 10px;
    right: 30px;
    height: 100px;
  }
}
.elvas-video {
  padding-top: 120px;
  .oh-elvas-footer-title {
    width: 80%;
    margin: 0 auto;
    display: block;
    margin-bottom: -5px;
  }
  img {
    width: 100%;
  }
  .elvas-video-container {
    width: 100%;
    max-height: 600px;
    overflow: hidden;
    video {
      width: 100%;
      margin-top: -200px;
    }
    .overlay {
      background: rgba(167, 147, 116, 0.5);
      height: 100%;
      width: 100%;
      position: absolute;
      top: 0;
    }
  }
}
.see-more {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-left: 30px;
  cursor: pointer;
  p {
    font-size: 14px;
    font-weight: bold;
    line-height: 1;
    letter-spacing: 1px;
    color: #f6b92f;
    text-transform: uppercase;
    margin-right: 10px;
  }
  & > a {
    display: flex;
    align-items: center;
    .see-more-icon {
      height: 50px;
      width: 50px;
      .filled {
        display: none;
        margin-top: -8px;
        margin-left: -8px;
      }
      &:hover {
        .no-filled {
          display: none;
        }
        .filled {
          display: block;
        }
      }
    }
  }
}
</style>